import { css, Interpolation, Theme } from '@emotion/react'
import { alpha } from '@mui/material'

export const wrapper: Interpolation<Theme> = (theme) => css`
  display: flex;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyTwo};
  position: relative;
`

export const oy = css`
  height: calc(100% - 20px);
  min-width: 33px;
  max-width: 33px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  user-select: none;
`

export const oyValue = (isFirst: boolean) => (theme: Theme) =>
  css`
    height: 20px;

    :after {
      content: '';
      display: block;
      position: absolute;
      left: 33px;
      margin-top: -10px;
      width: calc(100% - 33px);
      height: 1px;
      background: ${isFirst
        ? theme.backgrounds.backgroundOne
        : `repeating-linear-gradient(
          to right,
          ${theme.backgrounds.backgroundOne},
          ${theme.backgrounds.backgroundOne} 6px,
          transparent 6px,
          transparent 12px
        )`};
    }
  `

export const chart: Interpolation<Theme> = (theme) => css`
  flex: 1;
  padding-top: 10px;
  padding-right: 8px;
  width: 100%;
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  grid-auto-rows: auto;
  grid-template-rows: calc(100% - 30px) 20px;
  gap: 9px 16px;
  overflow-x: auto;

  ::-webkit-scrollbar {
    height: 7px;
  }
  ::-webkit-scrollbar-track {
    margin: 13px 0;
  }
  ::-webkit-scrollbar-thumb {
    background: ${theme.backgrounds.backgroundTwo};
    border-radius: 3px;
  }
`

export const column: Interpolation<Theme> = (theme: Theme) => css`
  height: 100%;
  width: 100%;
  min-width: 56px;
  position: relative;
  overflow: hidden;

  ${theme.breakpoints.down(1024)} {
    min-width: 27px;
  }

  ${theme.breakpoints.down(768)} {
    min-width: 27px;
  }
`

export const value: Interpolation<Theme> = css`
  margin: 0 -8px;
  text-align: center;
  user-select: none;

  &:last-child {
    margin-right: 0;
  }
`

export const item = (value: number) => (theme: Theme) =>
  css`
    height: ${value}%;
    width: 100%;
    position: absolute;
    bottom: 0;
    background: linear-gradient(180deg, ${theme.colors.backgroundOne} 0%, ${alpha(theme.colors.backgroundOne, 0)} 100%);
    backdrop-filter: blur(2px);
    border-radius: 8px 8px 0 0;

    :before {
      content: '';
      position: absolute;
      z-index: -1;
      inset: 0;

      padding: 1px;
      border-radius: 8px 8px 0 0;

      background: linear-gradient(to bottom, ${alpha(theme.colors.white, 0.15)}, ${alpha(theme.colors.white, 0)});
      mask: linear-gradient(#000 0 0) exclude, linear-gradient(#000 0 0) content-box;
    }
  `

export const growAnimation = (index: number) => css`
  animation: grow 800ms cubic-bezier(0.75, 0, 0.16, 0.89) both;
  animation-delay: ${index * 100}ms;

  @keyframes grow {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
`
